import { FC } from 'react'

import styled from 'styled-components'

import { DashboardInformationCard } from 'src/components/organisms'

import { useAuthority } from 'src/hooks'

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: var(--s1);
`

type Props = {
  className?: string
}

export const DashboardInformation: FC<Props> = ({ className }) => {
  const { canManageUser } = useAuthority()

  return (
    <div className={className}>
      <Container>
        {canManageUser ? (
          <>
            <DashboardInformationCard type="inviteUser" />
            <DashboardInformationCard type="createProject" />
          </>
        ) : (
          <DashboardInformationCard type="accessToCompass" />
        )}
      </Container>
    </div>
  )
}
